/**
 * This file contains the same enums as DataModels.ts, but declared as objects
 * These objects should only be used by consumers who cannot use const enums for whatever reason
 * Typically, users may encounter issues if they use ts-jest and isolatedModules.
 * Avoiding these EnumObjects saves 1.5KB in package size
 */

import {
  DataClassification as DataClassificationType,
  DataFieldType as DataFieldTypeType,
  SamplingPolicy as SamplingPolicyType,
  PersistencePriority as PersistencePriorityType,
  CostPriority as CostPriorityType,
  DataCategories as DataCategoriesType,
  DiagnosticLevel as DiagnosticLevelType,
  CustomerContentType as CustomerContentTypeType,
  LogLevel as LogLevelType,
  Category as CategoryType
} from '../DataModels';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace EnumObjects {
  export const DataClassification = {
    EssentialServiceMetadata: (1 << 0) as DataClassificationType,
    AccountData: (1 << 1) as DataClassificationType,
    SystemMetadata: (1 << 2) as DataClassificationType,
    OrganizationIdentifiableInformation: (1 << 3) as DataClassificationType,
    EndUserIdentifiableInformation: (1 << 4) as DataClassificationType,
    CustomerContent: (1 << 5) as DataClassificationType,
    AccessControl: (1 << 6) as DataClassificationType
  };

  export const DataFieldType = {
    // eslint-disable-next-line id-denylist
    String: 0 as DataFieldTypeType,
    // eslint-disable-next-line id-denylist
    Boolean: 1 as DataFieldTypeType,
    Int64: 2 as DataFieldTypeType,
    Double: 3 as DataFieldTypeType,
    Guid: 4 as DataFieldTypeType
  };

  export const SamplingPolicy = {
    NotSet: 0 as SamplingPolicyType,
    Measure: 1 as SamplingPolicyType,
    Diagnostics: 2 as SamplingPolicyType,
    CriticalBusinessImpact: 191 as SamplingPolicyType,
    CriticalCensus: 192 as SamplingPolicyType,
    CriticalExperimentation: 193 as SamplingPolicyType,
    CriticalUsage: 194 as SamplingPolicyType
  };

  export const PersistencePriority = {
    NotSet: 0 as PersistencePriorityType,
    Normal: 1 as PersistencePriorityType,
    High: 2 as PersistencePriorityType
  };

  export const CostPriority = {
    NotSet: 0 as CostPriorityType,
    Normal: 1 as CostPriorityType,
    High: 2 as CostPriorityType
  };

  export const DataCategories = {
    NotSet: 0x00 as DataCategoriesType,
    SoftwareSetup: 0x01 as DataCategoriesType,
    ProductServiceUsage: 0x02 as DataCategoriesType,
    ProductServicePerformance: 0x04 as DataCategoriesType,
    DeviceConfiguration: 0x08 as DataCategoriesType,
    InkingTypingSpeech: 0x10 as DataCategoriesType
  };

  export const DiagnosticLevel = {
    ReservedDoNotUse: 0 as DiagnosticLevelType,
    Required: 10 as DiagnosticLevelType,
    BasicEvent: 10 as DiagnosticLevelType,
    Optional: 100 as DiagnosticLevelType,
    FullEvent: 100 as DiagnosticLevelType,
    RequiredServiceData: 110 as DiagnosticLevelType,
    NecessaryServiceDataEvent: 110 as DiagnosticLevelType,
    RequiredServiceDataForEssentialServices: 120 as DiagnosticLevelType,
    AlwaysOnNecessaryServiceDataEvent: 120 as DiagnosticLevelType
  };

  export const CustomerContentType = {
    None: 0x0 as CustomerContentTypeType,
    MocaAddIn: 0x1 as CustomerContentTypeType
  };

  export const LogLevel = {
    Error: 0 as LogLevelType,
    Warning: 1 as LogLevelType,
    Info: 2 as LogLevelType,
    Verbose: 3 as LogLevelType
  };

  export const Category = {
    Core: 0 as CategoryType,
    Sink: 1 as CategoryType,
    Transport: 2 as CategoryType
  };
}
